import { useState, useEffect } from "react";
import Script from "next/script";

import Nav from "components/Layout/Nav/Nav";
import PageContainer from "components/PageContainer";

const Gift = () => {
  const [navHeight, setNavHeight] = useState(88);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    let desktopNavEl = document.getElementById("nav-desktop-container");
    let mobileNavEl = document.getElementById("nav-mobile");
    let relevantHeight = Math.max(
      desktopNavEl.scrollHeight,
      mobileNavEl.scrollHeight
    );
    setNavHeight(relevantHeight);
  };

  return (
    <div
      id="page-container"
      className="font-hn text-base min-h-screen"
      style={{
        backgroundColor: "#081311",
      }}
    >
      <PageContainer className="min-h-screen w-screen">
        <>
          <div id="">
            <Nav />
          </div>
          <div className="w-screen ">
            <div className="relative" style={{ paddingTop: `${navHeight}px` }}>
              <div
                className="gift-up-target"
                style={{ marginTop: "3em" }}
                data-site-id="59fb2fb0-591a-4839-1d45-08da2399d2c2"
                data-platform="Other"
              ></div>
            </div>
          </div>

          <Script
            id="giftup"
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `(function (g, i, f, t, u, p, s) {
            g[u] = g[u] || function() { (g[u].q = g[u].q || []).push(arguments) };
            p = i.createElement(f);
            p.async = 1;
            p.src = t;
            s = i.getElementsByTagName(f)[0];
            s.parentNode.insertBefore(p, s);
          })(window, document, "script", "https://cdn.giftup.app/dist/gift-up.js", "giftup");
        `,
            }}
          />
        </>
      </PageContainer>
    </div>
  );
};

export default Gift;
